const messages = {
  fleetWithOptions:
    "Sie können die Flotte nicht auswählen, wenn Sie Optionen ausgewählt haben.",
  addProduct: "Ihr Produkt wurden zum Warenkorb hinzugefügt.",
  addProducts: "Ihre Produkte wurden zum Warenkorb hinzugefügt.",
  profileSaved: "Die Daten Ihres Profils wurden gespeichert",
  canAddProduct: "Du hast nicht genug Punkte.",
  customerNumberSaved: "Kundennummer gespeichert",
  customerNumberExist: "Kundennummer existiert bereits",
  complaintForm:
    "Ihre Anfrage wurde angenommen. Bitte warten Sie auf eine Antwort",
  openHourSaved: "Öffnungszeiten wurden gespeichert",
  changeParentId:
    "Sie können die Zweigstelle mit der übergeordneten Kundennummer nicht ändern, wenn sie untergeordnete Zweige hat",
  requestSent: "Verzoek is verzonden",
  completeProfileRequired:
    "Sie sollten Ihr Profil mit 100 % ausfüllen, um mit dem Kauf im Shop fortzufahren.",
  accessDenied: "Zugriff abgelehnt",
  incomplete_address: "Adresse ist unvollständig. überprüfen Sie bitte",
  waitMoment: "Moment mal",
  downloadFinished: "Download beendet",
  selectOneField: "Wählen Sie ein Feld aus",
  noVoucher: "Gutschein wurde nicht gefunden",
  cannotAddCsNumber: "Sie können keine Kundennummer hinzufügen.",
  messagesDeletedSuccess: "Nachrichten wurden gelöscht.",
  messagesDeletedError: "Nachrichten konnten nicht gelöscht werden.",
  fillProfile:
    "Füllen Sie das Profil aus, um das Zertifikat herunterladen zu können,",
  favoriteAdded: "Zu Favoriten hinzugefügt.",
  favoriteRemoved: "Aus Favoriten entfernt.",
};

export default {
  messages,
};
